import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Settings, Volume2, VolumeX, Moon, Sun } from 'lucide-react';
import { useProgress } from '@/hooks/useProgress';

export function Header() {
  const { progress, updateSettings } = useProgress();
  const { soundEnabled, darkMode } = progress.settings;

  const toggleSound = () => {
    updateSettings({ soundEnabled: !soundEnabled });
  };

  const toggleDarkMode = () => {
    updateSettings({ darkMode: !darkMode });
    document.documentElement.classList.toggle('dark', !darkMode);
  };

  return (
    <header className="sticky top-0 z-40 safe-top">
      <div className="glass border-b border-white/20 dark:border-slate-700/50">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <motion.div
              animate={{ rotate: [0, -10, 10, -5, 5, 0] }}
              transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 3 }}
              className="text-2xl"
            >
              🦦
            </motion.div>
            <span className="font-display font-bold text-lg text-otter-700 dark:text-otter-300">
              Otter Expert
            </span>
          </Link>

          <div className="flex items-center gap-2">
            {/* XP Display */}
            <div className="hidden sm:flex items-center gap-1 px-3 py-1 bg-amber-100 dark:bg-amber-900/50 rounded-full">
              <span className="text-amber-600 dark:text-amber-400 text-sm font-bold">
                {progress.globalStats.totalXp.toLocaleString()} XP
              </span>
            </div>

            {/* Sound Toggle */}
            <button
              onClick={toggleSound}
              className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              aria-label={soundEnabled ? 'Mute sounds' : 'Enable sounds'}
            >
              {soundEnabled ? (
                <Volume2 className="w-5 h-5 text-slate-600 dark:text-slate-400" />
              ) : (
                <VolumeX className="w-5 h-5 text-slate-400 dark:text-slate-500" />
              )}
            </button>

            {/* Dark Mode Toggle */}
            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              aria-label={darkMode ? 'Light mode' : 'Dark mode'}
            >
              {darkMode ? (
                <Sun className="w-5 h-5 text-yellow-500" />
              ) : (
                <Moon className="w-5 h-5 text-slate-600 dark:text-slate-400" />
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
